import React from "react";

const Footer = () => {
  return (
    <div className="footer grid center">
      <div className="container">
        <div className="grid center cross-center between">
          <div className="u-16 u-ms text-center">
            <a href="tel:+74951233403">+7 495 123 34 03</a>
          </div>
          <div className="u-16 u-ms text-center ver-padding-5">
            <a href="mailto:hello@mapcard.pro">hello@mapcard.pro</a>
          </div>
          <div className="u-16 u-ms text-center">
            <span>© MAP LLC 2015-2021</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
